import React from 'react'

const TextInput = ({ index, name, fieldname, onChange, value }) => {
  const TYPE = "text";

  const handleInputChange = (event) => {
    onChange(event, TYPE, fieldname);
  };

  const handleClear = () => {
      const event = { target: { value: "" } };
      onChange(event, TYPE, fieldname);
  };

  return (
    <div className="side-input mt-2 mb-2">
      <label className="mb-0 w-100" htmlFor={`text-${index}`}>{name}
        <div className="input-group">
            <input value={value ?? ""} onChange={e => handleInputChange(e)} type="search" className="form-control" id={`text-${index}`} />
            {value && (
              <div className="input-group-append">
                <button 
                    className="btn btn-outline-secondary" 
                    type="button" 
                    onClick={handleClear}
                    aria-label="Clear"
                >
                    ×
                </button>
              </div>
            )}
        </div>
      </label>
    </div>
  )
}

export default TextInput